module.exports = __webpack_public_path__ + "static/media/tinyHomepage2.cb6a7704.png";